<ng-container
  [ngTemplateOutlet]="template"
  [ngTemplateOutletContext]="{
    opened: opened | async,
    showToggle: showToggle | async,
    menuMode: menuMode | async,
    pageMode: pageMode | async
  }"
>
</ng-container>

<ng-template
  #template
  let-opened="opened"
  let-showToggle="showToggle"
  let-menuMode="menuMode"
  let-pageMode="pageMode"
>
  <mat-drawer-container autosize class="drawer-container" flexFill>
    <mat-drawer #drawer [mode]="menuMode!" [opened]="opened">
      <div flexLayout="column" flexLayoutAlign="space-between stretch" flexFill>
        <div flexLayout="column" flexLayoutAlign="start stretch" flexFill>
          <!--
            Start Top Section
          -->
          <div flexLayout="row" flexLayoutAlign="space-between stretch" class="menu-actions">
            <div></div>
            <mat-icon class="icon" *ngIf="opened" (click)="toggleSideNav()"
              >keyboard_arrow_left</mat-icon
            >
            <mat-icon class="icon" *ngIf="!opened" (click)="toggleSideNav()">menu</mat-icon>
          </div>
          <!--
            End Top Section
          -->
          <div flexLayout="column" flex="calc(100% - 40px)" *ngIf="opened">
            <div class="menu-section" flex="0 1 auto" flexLayout="column">
              <!--
                Start Menu Header
              -->
              <div class="menu-header" flexLayout="row" flexLayoutAlign="space-between center">
                <div flexLayout="row" flexLayoutAlign="start center">Administration</div>
                <div class="notification-area" flexLayout="row" flexLayoutAlign="center center">
                  <vp-spinner
                    [overlay]="false"
                    forApiUrl="/casesummary"
                    [diameter]="18"
                  ></vp-spinner>
                </div>
              </div>
              <!--
                End Menu Header
              -->

              <div class="overflow-scroll">
                <div class="menu-section">
                  <div flexLayout="column" flexLayoutAlign="start stretch">
                    <div
                      class="menu-item"
                      flexLayout="row"
                      flexLayoutAlign="space-between center"
                      [routerLink]="['/', 'administration', 'users']"
                      routerLinkActive="active"
                      *ngxPermissionsOnly="[permConst.Admin.User.Read]"
                    >
                      <div flexLayout="row" flexLayoutAlign="start center">
                        {{ "userListPageNav" | uiDisplayTags }}
                      </div>
                      <div
                        matBadgePosition="after"
                        matBadgeSize="medium"
                        flexLayout="row"
                        flexLayoutAlign="start center"
                        class="notification-area"
                      ></div>
                    </div>

                    <div
                      class="menu-item"
                      flexLayout="row"
                      flexLayoutAlign="space-between center"
                      [routerLink]="['/', 'administration', 'invite-user-page']"
                      [queryParams]="{ returnUrl: 'users' }"
                      routerLinkActive="active"
                      *ngxPermissionsOnly="[permConst.Admin.InviteUser.Write]"
                    >
                      <div flexLayout="row" flexLayoutAlign="start center">
                        {{ "inviteUserPageNav" | uiDisplayTags }}
                      </div>
                      <div
                        matBadgePosition="after"
                        matBadgeSize="medium"
                        flexLayout="row"
                        flexLayoutAlign="start center"
                        class="notification-area"
                      ></div>
                    </div>

                    <div
                      class="menu-item"
                      flexLayout="row"
                      flexLayoutAlign="space-between center"
                      [routerLink]="['/', 'administration', 'casetypes']"
                      routerLinkActive="active"
                      *ngxPermissionsOnly="[permConst.Admin.CaseType.Write]"
                    >
                      <div flexLayout="row" flexLayoutAlign="start center">
                        {{ "casetypePageNav" | uiDisplayTags }}
                      </div>
                      <div
                        matBadgePosition="after"
                        matBadgeSize="medium"
                        flexLayout="row"
                        flexLayoutAlign="start center"
                        class="notification-area"
                      ></div>
                    </div>

                    <div
                      class="menu-item"
                      flexLayout="row"
                      flexLayoutAlign="space-between center"
                      [routerLink]="['/', 'administration', 'devices']"
                      routerLinkActive="active"
                      *ngxPermissionsOnly="[permConst.Admin.Device.Read]"
                    >
                      <div flexLayout="row" flexLayoutAlign="start center">
                        {{ "deviceListPageNav" | uiDisplayTags }}
                      </div>
                      <div
                        matBadgePosition="after"
                        matBadgeSize="medium"
                        flexLayout="row"
                        flexLayoutAlign="start center"
                        class="notification-area"
                      ></div>
                    </div>

                    <ng-template featureFlag="acesoTv" feature="virtualCare">
                      <div
                        class="menu-item"
                        flexLayout="row"
                        flexLayoutAlign="space-between center"
                        [routerLink]="['/', 'administration', 'tvs']"
                        routerLinkActive="active"
                        *ngxPermissionsOnly="[permConst.Global.TelevisionManagerPage.View]"
                      >
                        <div flexLayout="row" flexLayoutAlign="start center">
                          {{ "tvListPageNav" | uiDisplayTags }}
                        </div>
                        <div
                          matBadgePosition="after"
                          matBadgeSize="medium"
                          flexLayout="row"
                          flexLayoutAlign="start center"
                          class="notification-area"
                        ></div>
                      </div>
                    </ng-template>

                    <div
                      class="menu-item"
                      flexLayout="row"
                      flexLayoutAlign="space-between center"
                      [routerLink]="['/', 'administration', 'tagmanager']"
                      routerLinkActive="active"
                      *ngxPermissionsOnly="[permConst.Global.AdminTagsPage.View]"
                    >
                      <div flexLayout="row" flexLayoutAlign="start center">
                        {{ "tagsListPageNav" | uiDisplayTags }}
                      </div>
                      <div
                        matBadgePosition="after"
                        matBadgeSize="medium"
                        flexLayout="row"
                        flexLayoutAlign="start center"
                        class="notification-area"
                      ></div>
                    </div>

                    <div
                      class="menu-item"
                      flexLayout="row"
                      flexLayoutAlign="space-between center"
                      [routerLink]="['/', 'administration', 'schedule-maintenance']"
                      routerLinkActive="active"
                      *ngxPermissionsOnly="[permConst.Admin.Schedule.Write]"
                    >
                      <div flexLayout="row" flexLayoutAlign="start center">
                        {{ "scheduleMaintenanceNav" | uiDisplayTags }}
                      </div>
                      <div
                        matBadgePosition="after"
                        matBadgeSize="medium"
                        flexLayout="row"
                        flexLayoutAlign="start center"
                        class="notification-area"
                      ></div>
                    </div>

                    <div
                      class="menu-item"
                      flexLayout="row"
                      flexLayoutAlign="space-between center"
                      [routerLink]="['/', 'administration', 'accounting']"
                      routerLinkActive="active"
                      *ngxPermissionsOnly="[permConst.Admin.Accounting.Read]"
                    >
                      <div flexLayout="row" flexLayoutAlign="start center">
                        {{ "accountingPageNav" | uiDisplayTags }}
                      </div>
                      <div
                        matBadgePosition="after"
                        matBadgeSize="medium"
                        flexLayout="row"
                        flexLayoutAlign="start center"
                        class="notification-area"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-drawer>
    <mat-drawer-content #content>
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </mat-drawer-content>
  </mat-drawer-container>
</ng-template>

<ng-template #contentTemplate>
  <div flexFill flexLayout="column" flexLayoutAlign="start stretch" class="content">
    <div
      flexLayout="row"
      flexLayout.lt-sm="column"
      flexLayoutAlign="space-between center"
      flexLayoutAlign.lt-sm="start start"
    >
      <vp-breadcrumb></vp-breadcrumb>
      <vp-page-menu></vp-page-menu>
    </div>
    <div flex flexLayout="column">
      <ng-content></ng-content>
      <router-outlet></router-outlet>
    </div>
  </div>
</ng-template>
